import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@constant/colors';

const SearchCircle = ({ className, color }) => (
  <svg className={className} width="24" height="24">
    <path
      fill={color}
      d="M15.31 13.8957l1.397 1.3972c.3906.39.3906 1.0232 0 1.414-.3904.3902-1.0236.3902-1.414 0l-1.3973-1.397c-.6937.437-1.5152.69-2.3957.69C9.0147 16 7 13.985 7 11.5S9.0147 7 11.5 7 16 9.0147 16 11.5c0 .8805-.253 1.702-.69 2.3957zM0 12C0 5.3726 5.3726 0 12 0s12 5.3726 12 12-5.3726 12-12 12S0 18.6274 0 12zm22 0c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10 10-4.4772 10-10zm-10.5 2c1.3807 0 2.5-1.1193 2.5-2.5S12.8807 9 11.5 9 9 10.1193 9 11.5s1.1193 2.5 2.5 2.5z"
    />
  </svg>
);

SearchCircle.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

SearchCircle.defaultProps = {
  color: DODGER_BLUE,
};

export default SearchCircle;
